var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"badge badge-info status",style:({backgroundColor: _vm.getStatusColor(_vm.status)})},[_vm._v(" "+_vm._s(_vm.getStatusLabel(_vm.status))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }